module.exports = __webpack_public_path__ + "static/media/product_5.fc006392.png";